export default __webpack_public_path__ + "static/media/userIconClicked.f78bfdb3.svg";